import React, { useMemo } from "react";
import ScoreStar from "../ScoreStar";
import { isNill } from "../../../../utils/common";
import style from "./index.module.scss";

interface Props {
  totalScore: number;
  detailList?: { name: string; score: number }[];
}

// 满分
const FullScore = 5;

const ScoreStarDetail = ({ totalScore, detailList }: Props) => {
  // 重新处理分值
  const _totalScore = useMemo(() => {
    if (isNill(totalScore)) return "4.9"; // 无值或数据异常，默认 4.9
    else if (totalScore < 3)
      return "3.0"; // 特殊考虑：低于 3.0 评分，按 3.0 显示
    else if (totalScore > 5) return "5.0"; // 特殊考虑：任何高于 5.0 评分，按 5.0 显示，因为总分只有 5.0
    return (Math.floor(totalScore * 10) / 10).toFixed(1); // 其他取小数点后一位
  }, [totalScore]);

  return (
    <span className={style.scoreStarDetailComp}>
      <span className={style.leftPart}>
        {detailList &&
          detailList.map((item) => {
            let { score } = item;
            if (isNill(item?.score)) score = 4.9; // 无值或数据异常，默认细项 4.9
            let itemWidth = (score ?? 0) / FullScore;
            itemWidth = itemWidth > 1 ? 1 : itemWidth;
            return (
              <div className={style.item}>
                <span className={style.name}>{item?.name}</span>
                <span className={style.totalLine}>
                  <span
                    className={style.realLine}
                    style={{
                      width: `${itemWidth * 100}%`,
                    }}
                  />
                </span>
              </div>
            );
          })}
      </span>
      <span className={style.rightPart}>
        <div className={style.score}>{_totalScore}</div>
        <div className={style.desc}>更多评分</div>
        <ScoreStar score={totalScore} showScore={false} />
      </span>
    </span>
  );
};

export default ScoreStarDetail;
